/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template_update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateProps,
  EngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateResult,
} from "./types";

export const postEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedState =
  reactQueryMutationAdapter(
    engagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateCacheKeys,
    ({
      appGroupId,
      templateIds,
      markAsArchived,
    }: PostEngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateProps): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateUpdateArchivedStateResult> => {
      return fetch(
        `/engagement/${appGroupId}/structural_template/canvas_template_update_archived_state`,
        "POST",
        {
          template_ids: templateIds,
          mark_as_archived: markAsArchived,
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  );
